module.exports = __webpack_public_path__ + "static/media/co.612dec34.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/co.svg
// module id = 90
// module chunks = 0